import Vue from 'vue'
import Router from 'vue-router'

const appIndex = r => require.ensure([], () => r(require('@/view/home/index.vue')), 'home_components');
const home = r => require.ensure([], () => r(require('@/view/home.vue')), 'home_components');
const biz = r => require.ensure([], () => r(require('@/view/home/biz.vue')), 'home_components');
const application = r => require.ensure([], () => r(require('@/view/application/application.vue')), 'application_components');

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: home,
            redirect: '/index',
            meta: {
                title: '设备耗材助手'
            },
        },
        {path: '/index', component: appIndex, meta: {title: '设备耗材助手'}},
        {
            path: '/application',
            name: 'application',
            component: application,
            meta: {
                title: '设备耗材助手'
            },
        },
        {
            path: '/biz',
            name: 'biz',
            component: biz,
            meta: {
                title: '设备耗材助手'
            },
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js